export const EDUTAINMENT_CATEGORY_OPTIONS = [
  {
    label: '技藝',
    value: '技藝',
  },
  {
    label: '運動',
    value: '運動',
  },
  {
    label: '健康',
    value: '健康',
  },
];

export const PLAN_OPTIONS = [
  {
    label: '銅卡會員',
    value: '銅卡會員',
  },
  {
    label: '銀卡會員',
    value: '銀卡會員',
  },
  {
    label: '金卡會員',
    value: '金卡會員',
  },
  {
    label: '白金卡會員',
    value: '白金卡會員',
  },
  {
    label: '翡翠卡會員',
    value: '翡翠卡會員',
  },
  {
    label: '鑽卡會員',
    value: '鑽卡會員',
  },
];

export const TEACHER_OPTIONS = [
  {
    label: '王良田',
    value: '王良田',
  },
  {
    label: '李廣',
    value: '李廣',
  },
  {
    label: '趙三郎',
    value: '趙三郎',
  },
  {
    label: '劉玉慈',
    value: '劉玉慈',
  },
  {
    label: '林佑明',
    value: '林佑明',
  },
  {
    label: '盧軒慶',
    value: '盧軒慶',
  },
];
